import { defineStore } from 'pinia';

export const useProductStore = defineStore('product', {
  state: () => ({
    loaded: false,
    loading: false,
    products: [] as Product[],
  }),
  actions: {
    async load() {
      if (!this.loaded && !this.loading) {
        await this.reload();
      }
    },
    async reload() {
      this.loading = true;
      const { data } = await useApi().get<Product[]>(`/shop/products`);
      this.products = data.value;
      this.loaded = true;
      this.loading = false;
    },
  },
});
